const USER_SETTINGS_DOCTYPE_MAX_LENGTH = 180;

const getShortHash = (value) => {
    let hash = 2166136261;
    for (let index = 0; index < value.length; index += 1) {
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36);
};

const getSortSettingsDoctype = (prefix, scopeId, fallbackScopeId) => {
    const normalizedScopeId = String(scopeId || fallbackScopeId);
    const fullKey = `${prefix}${normalizedScopeId}`;
    if (fullKey.length <= USER_SETTINGS_DOCTYPE_MAX_LENGTH) {
        return fullKey;
    }

    const hash = getShortHash(normalizedScopeId);
    const separator = "::";
    const availableScopeLength =
        USER_SETTINGS_DOCTYPE_MAX_LENGTH -
        prefix.length -
        separator.length -
        hash.length;

    return `${prefix}${normalizedScopeId.slice(
        0,
        availableScopeLength
    )}${separator}${hash}`;
};

export const getItemSortSettingsDoctype = (itemGroupId) =>
    getSortSettingsDoctype(
        "pos_item_order::",
        itemGroupId,
        "All Item Groups"
    );

export const getGroupSortSettingsDoctype = (rootGroupId) =>
    getSortSettingsDoctype(
        "pos_group_order::",
        rootGroupId,
        "All Item Groups"
    );

export const getSubGroupSortSettingsDoctype = (parentGroupId) =>
    getSortSettingsDoctype(
        "pos_subgroup_order::",
        parentGroupId,
        "All Item Groups"
    );

export const buildSortOrder = (items, itemKey) =>
    (Array.isArray(items) ? items : [])
        .map((item) => item?.[itemKey])
        .filter(Boolean);

export const getSavedSortOrder = ({
    settings,
    orderKey,
    legacyIndices,
    legacyEntryKey,
}) => {
    if (
        settings &&
        Object.prototype.hasOwnProperty.call(settings, orderKey)
    ) {
        return Array.isArray(settings[orderKey])
            ? settings[orderKey].filter(Boolean)
            : [];
    }

    return (Array.isArray(legacyIndices) ? [...legacyIndices] : [])
        .sort((a, b) => Number(a?.index || 0) - Number(b?.index || 0))
        .map((entry) => entry?.[legacyEntryKey])
        .filter(Boolean);
};
